export default function Marquee() {
  const items = [
    "Enterprise Program Leader",
    "₹3,200+ Cr CAPEX Governed",
    "21+ Years of Practice",
    "Independent Director Candidate",
    "Board Stewardship — All Sectors",
    "PMP® · PMI-ACP® · FIE · CEng",
  ];
  const track = [...items, ...items, ...items];
  return (
    <section aria-hidden className="relative border-y border-surface-2 overflow-hidden bg-[#0d1b30]">
      <div className="marquee-track flex whitespace-nowrap py-10 will-change-transform">
        {track.map((t, i) => (
          <span
            key={i}
            className="flex items-center font-serif-display italic text-ivory/90 text-4xl md:text-6xl px-10 shrink-0"
          >
            {t}
            <span className="ml-10 inline-block h-2 w-2 bg-brass" />
          </span>
        ))}
      </div>
    </section>
  );
}
